import { render, staticRenderFns } from "./BankInstallmentView.vue?vue&type=template&id=f9aadcd0"
import script from "./BankInstallmentView.vue?vue&type=script&lang=js"
export * from "./BankInstallmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports